import * as React from "react";
import { Box, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";
import AdminOnboardForm from "../../components/forms/adminOnboardForm";
import CommonBankAccountNumber from "../../components/commonBankAccountNumber";
import CommonBanksSelect from "../../components/commonBanksSelect";
import theme from "../../theme";
import AdminSuccessModal from "./successModal";
import history from "../../history";

import {
  onBoardEmployeeInfoAction,
  onBoardEmployeeVerifyAction,
} from "./action";

const useStyles = makeStyles(() => ({
  fieldInput: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 9, fontSize: 13.5,
      fontFamily: theme.fontFamily.MARKPROBOOK,
      backgroundColor: "#FAFCFF",
      "& fieldset": { borderColor: theme.colors.Gallery, borderWidth: 1.5 },
      "&:hover fieldset": { borderColor: theme.colors.Periwinkle },
      "&.Mui-focused fieldset": { borderColor: theme.colors.DodgerBlue },
    },
  }
}));

export default function AdminConfirmRegistration({ match }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  console.log(match)

  const onBoardEmployeeInfoMethod = React.useCallback(
    (data) => {
      dispatch(onBoardEmployeeInfoAction(data));
    }
    , [dispatch]);
  const employeeRegistrationReducer = useSelector((state) => {
    return state.employeeRegistrationReducer;
  });
  const [submitted, setSubmitted] = React.useState(false);
  const [formData, setFormData] = React.useState({
    first_name: "", last_name: "", email: "",
    gender: "", branch: "",
    password: "",
    profile: { position: "", phone: "", salary: "", savings: "", limit: "", nin: "", bvn: "" },
    banks: { number: "" },
  });


  React.useEffect(() => {
    const { cid, aid } = match.params;
    if (cid && aid) {
      onBoardEmployeeInfoMethod({ cid: cid, eid: aid });
    }
  }, [match.params, onBoardEmployeeInfoMethod]);

  React.useEffect(() => {
    if (employeeRegistrationReducer && employeeRegistrationReducer.onBoardEmploeeinfo && !submitted) {
      const { first_name, last_name, email, gender, branch, profile, banks } = employeeRegistrationReducer.onBoardEmploeeinfo;

      setFormData({
        first_name: first_name || "",
        last_name: last_name || "",
        email: email || "",
        gender: gender || "",
        branch: branch || "",
        profile: {
          position: profile?.position || "",
          phone: profile?.phone || "",
          salary: profile?.salary || "",
          nin: profile?.nin || "",
          bvn: profile?.bvn || "",
        },
        banks: banks.length > 0 ? banks[0] || { number: "" } : { number: "" },
      });
    }
  }, [employeeRegistrationReducer]);

  return (
    <Box
      style={{
        minHeight: "100vh",
        background: "#F5F6F7",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        padding: "40px 16px",
      }}
    >
      <AdminSuccessModal
        open={submitted && employeeRegistrationReducer?.success}
        onClose={() => {
          dispatch({ type: "ONBOARD_EMPLOYEE_VERIFY_SUCCESS", payload: null });
        }}
        onDone={() => {
          history.push("/");
        }}
        adminName={formData.first_name}
        adminEmail={formData.email}
        permission={employeeRegistrationReducer?.onBoardEmploeeinfo?.is_admin ? "ADMIN" : "HR"}
      />
      <Box style={{ width: "100%", maxWidth: 640 }}>
        {employeeRegistrationReducer?.error?.length ? (
          <div className={"error-container"}>
            {employeeRegistrationReducer.error.map((each, index) => (
              <div key={index}>
                {each === "Resource not found."
                  ? "Token does not exist or has expired."
                  : each}
              </div>
            ))}
          </div>
        ) : null}
        <AdminOnboardForm
          title={`${employeeRegistrationReducer?.onBoardEmploeeinfo?.is_admin?'Admin': 'HR'} Onboarding`}
          setForm={setFormData}
          form={formData}
          error={(Array.isArray(employeeRegistrationReducer.error) && employeeRegistrationReducer.error.length >= 1)}
          bankAccountComponent={
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <CommonBanksSelect
                  value={
                    formData.banks?.name && formData.banks?.code
                      ? { label: formData.banks?.name, value: formData.banks?.code }
                      : { label: "", value: "" }
                  }
                  onChange={(data) =>
                    setFormData({ ...formData, banks: { ...formData.banks, name: data?.label, code: data?.value } })
                  }
                  className={classes.fieldInput}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <CommonBankAccountNumber
                  value={{
                    account_number: formData.banks.account_number || "",
                    account_name: formData.banks.account_name || "",
                    bank_code: formData.banks.code || ""
                  }}
                  onChange={(e) => {
                    setFormData({ ...formData, banks: { ...formData.banks, ...e } })
                  }}
                />
              </Grid>
            </Grid>
          }
          loading={employeeRegistrationReducer?.loading}
          onConfirmRegistration={() => {
            setSubmitted(true);
            dispatch(onBoardEmployeeVerifyAction({
              cid: match.params.cid, eid: match.params.aid, data: {
                first_name: formData.first_name,
                last_name: formData.last_name,
                email: formData.email,
                gender: formData.gender,
                branch: formData.branch,
                password: formData.password,
                profile: {
                  position: formData.profile.position,
                  phone: formData.profile.phone,
                  salary: formData.profile.salary,
                  savings: formData.profile.savings,
                  nin: formData.profile.nin,
                  bvn: formData.profile.bvn,
                },
                banks: [
                  {
                    name: formData.banks.name,
                    code: formData.banks.code,
                    number: formData.banks.account_number,
                    account_holder: formData.banks.account_name,
                  }
                ]
              }
            }));
          }}
        />
      </Box>
    </Box>
  );
}